import { REQUEST_CARS, RESPONSE_CARS, REQUEST_CARS_FAILURE } from "../actions/carsActions";
import {
  REQUEST_RECIEVE_UNITS_LAST_STATE,
  RESPONSE_RECIEVE_UNITS_LAST_STATE,
  REQUEST_STOP_RECIEVE_UNITS_LAST_STATE,
  RESPONSE_CLOSE_CONNECTION_MAP_SIGNALR,
} from "../actions/signalRActions";

import {
  REQUEST_CREATE_DRIVER_UNIT,
  RESPONSE_CREATE_DRIVER_UNIT,
  REQUEST_CREATE_DRIVER_UNIT_FAULURE,
  REQUEST_DELETE_DRIVER_UNIT,
  RESPONSE_DELETE_DRIVER_UNIT,
  REQUEST_DELETE_DRIVER_UNIT_FAULURE,
} from "../actions/driversAction";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  dataState: queriesStates.NOT_REQUESTED,
  dataRecieveUnitsLastState: queriesStates.NOT_REQUESTED,
  driverAddUnitDataState: queriesStates.NOT_REQUESTED,
  driverDeleteUnitDataState: queriesStates.NOT_REQUESTED,
  error: {},
  units: [],
  total: 0,
  filterCount: 0,
};

const carsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CARS: {
      return Object.assign({}, state, {
        dataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_CARS: {
      return Object.assign(
        {},
        state,
        {
          dataState: queriesStates.READY,
        },
        action.data
      );
    }
    case REQUEST_CARS_FAILURE: {
      return Object.assign({}, state, {
        dataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_RECIEVE_UNITS_LAST_STATE: {
      return Object.assign({}, state, {
        dataRecieveUnitsLastState: queriesStates.REQUEST,
      });
    }
    case RESPONSE_RECIEVE_UNITS_LAST_STATE: {
      let units = [...state.units];
      let isUpdate = false;
      const updateUnitData = action.data;

      units.forEach((unit, index) => {
        if (updateUnitData[unit.id] !== undefined) {
          isUpdate = true;
          units[index] = {
            ...units[index],
            gpsSignal: updateUnitData[unit.id].gpsSignal,
            lastActive: new String(updateUnitData[unit.id].lastActive),
            lastLocation: { ...updateUnitData[unit.id].lastLocation },
            status: { ...updateUnitData[unit.id].status },
          };
        }
      });

      return isUpdate
        ? Object.assign({}, state, {
            dataRecieveUnitsLastState: queriesStates.READY,
            units: units,
          })
        : state;
    }
    case REQUEST_STOP_RECIEVE_UNITS_LAST_STATE: {
      return Object.assign({}, state, {
        dataRecieveUnitsLastState: queriesStates.NOT_REQUESTED,
      });
    }

    case RESPONSE_CLOSE_CONNECTION_MAP_SIGNALR: {
      return Object.assign({}, state, {
        dataRecieveUnitsLastState: queriesStates.NOT_REQUESTED,
      });
    }

    case REQUEST_CREATE_DRIVER_UNIT: {
      return Object.assign({}, state, {
        driverAddUnitDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_CREATE_DRIVER_UNIT: {
      return Object.assign(
        {},
        state,
        {
          driverAddUnitDataState: queriesStates.READY,
          units: state.units.map((x) => {
            if (x.id === action.unitId) {
              x.drivers = x.drivers.concat(action.data);
            }

            return x;
          }),
        },
        action.data
      );
    }
    case REQUEST_CREATE_DRIVER_UNIT_FAULURE: {
      return Object.assign({}, state, {
        driverAddUnitDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_DELETE_DRIVER_UNIT: {
      return Object.assign({}, state, {
        driverDeleteUnitDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_DELETE_DRIVER_UNIT: {
      return Object.assign(
        {},
        state,
        {
          driverDeleteUnitDataState: queriesStates.READY,
          units: state.units.map((x) => {
            if (x.id === action.unitId) {
              x.drivers = x.drivers.filter((d) => {
                return d.id !== action.driverId;
              });
            }

            return x;
          }),
        },
        action.data
      );
    }
    case REQUEST_DELETE_DRIVER_UNIT_FAULURE: {
      return Object.assign({}, state, {
        driverDeleteUnitDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }
    default:
      return state;
  }
};

export default carsReducer;
